import { ChainId } from 'constants/chains'

export function constructSameAddressMap<T extends string>(address: T): { [chainId in ChainId]: T } {
  const chainIds = Object.values(ChainId).filter((value) => typeof value === 'number') as ChainId[];

  return chainIds.reduce((acc, chainId) => {
    return { ...acc, [chainId]: address };
  }, {} as { [chainId in ChainId]: T });
}
